var linkify = require('linkifyjs');
var linkifyString = require('linkifyjs/string');

module.exports = angular.module('filters.linkify', []).filter('linkify', function ($sce) {
  return function (input) {
    if (input == null) return $sce.trustAsHtml('');

    // we can trust the results of linkifyString - it escapes HTML going into it
    return $sce.trustAsHtml(linkifyString(input));
  };
});
